import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import UsageTracker from 'academy-common-lib/utils/UsageTracker';
import { useUpdatePlaylist, usePlaylist } from '../savedItemsQueries';
import { PlaylistForm } from './PlaylistForm';
import { jsx as _jsx } from "react/jsx-runtime";
export const EditPlaylistModal = ({
  playlistId,
  onRequestClose
}) => {
  const {
    playlist,
    playlistLoading
  } = usePlaylist(playlistId, !playlistId);
  const [updatePlaylist, {
    updatePlaylistMutationLoading
  }] = useUpdatePlaylist(playlistId, {
    onCompleted: () => {
      UsageTracker.trackStandalone('Playlist Interaction', {
        action: 'playlist-details-updated'
      });
      onRequestClose();
    },
    onError: () => {
      FloatingAlertStore.addAlert({
        message: I18n.text('academyCommon.savedItems.tooltips.savePlaylistError'),
        type: 'danger'
      });
    }
  });
  const onSubmit = values => {
    if (!playlist) {
      return;
    }
    updatePlaylist(Object.assign({}, values, {
      items: playlist.items
    })).catch(() => {});
  };
  const onCancel = () => {
    UsageTracker.trackStandalone('Playlist Interaction', {
      action: 'close-create-modal'
    });
  };
  return /*#__PURE__*/_jsx(PlaylistForm, {
    formLoadedMarker: null,
    initialValues: {
      name: (playlist === null || playlist === void 0 ? void 0 : playlist.name) || '',
      description: (playlist === null || playlist === void 0 ? void 0 : playlist.description) || ''
    },
    loading: updatePlaylistMutationLoading || playlistLoading,
    onCancel: onCancel,
    onRequestClose: onRequestClose,
    onSubmit: onSubmit,
    submitButtonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.common.save"
    }),
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.playlists.editDetails"
    })
  });
};